import ReviewForm from 'components/organisms/ReviewForm'
import * as React from 'react'
import { IReviewFormProps } from './new'

interface IProps extends IReviewFormProps {
  token: string
}

// ユーザーと一緒に来た参加者用レビュー
const ReviewNewForNonUser: React.FC<IProps> = props => {
  return <ReviewForm {...props} />
}

export default ReviewNewForNonUser
